import React from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { QRCode } from "react-qr-svg";
import "./qrcode.css"

export default class Qr extends React.Component {
    render() {
        return (
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                sx={{
                    backgroundColor: "#fff",
                    padding: 2,
                    maxWidth: 180,
                    margin: "auto",
                }}
            >
                
                {/* <Box display="flex" alignItems="center" mb={2}>
                    <span className="iconPrint">
                        <CheckCircleIcon sx={{ color: "green", mr: 1 }} />
                    </span>
                    <Typography variant="h6" fontWeight="bold">
                        Seu QR code está pronto
                    </Typography>
                </Box> */}

                <Box className="qr-wrapper">
                    <span className="corner bl"></span>
                    <span className="corner br"></span>
                    <QRCode
                        value={this.props.valor}
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        level="Q"
                        style={{ width: 140 }}
                    />
                </Box>
            </Box>
        );
    };
} 
